import { ColDef, ColumnState } from 'ag-grid-community';
import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { BancoItauDataCollection, BancoItauGroups } from './banco-itau.model';

@Injectable({
  providedIn: 'root'
})
export class BancoItauService {

  constructor(
    private cvApiService: CVApiService,
  ) { }

  public async getSettings(moduleKey: string): Promise<BancoItauGroups> {
    let renderEndpoint: string;
    try {
        renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
    } catch (err) {
        console.error("Failed getting module render endpoint");
        throw err;
    }

    try {
        const url = `/api/v2/dashboards/modules/bancoItau/${encodeURIComponent(moduleKey)}/settings`;
        const response = await this.cvApiService.get<BancoItauGroups>(url, renderEndpoint);
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        else throw response;
    }
    catch (err) {
        console.error("Failed getting settings for Banco Itau module");
        throw err;
    }
}

  public async loadData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false): Promise<BancoItauDataCollection>{
    let renderEndpoint: string;
    try {
      renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
    } catch (err) {
      console.error("Failed getting module render endpoint");
      throw err;
    }
    try {
      const url = `/api/v2/dashboards/modules/bancoItau/${encodeURIComponent(moduleKey)}`;
      const urlOptions = `?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
      const response = await this.cvApiService.get<BancoItauDataCollection>(url + urlOptions, renderEndpoint);
      if (response.status_code >= 200 && response.status_code < 300)
          return response.data;
      else throw response;
    } catch (err) {
      console.error("Failed getting data for Banco Itau widget");
    } 
  }

  public async getExport(moduleKey: string, format: ModuleManagerExportFormat){
    let renderEndpoint: string;
    try {
      renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
    } catch (err) {
      console.error("Failed getting module render endpoint");
      throw err;
    }


    try {
      const url = `/api/v2/dashboards/modules/bancoItau/${encodeURIComponent(moduleKey)}` + `/export?format=${format}`;
      const response = await this.cvApiService.get<string>(url, renderEndpoint);
      if (response.status_code >= 200 && response.status_code < 300)
        return response;
      else throw response;
    } catch (err) {
      console.error("Failed getting data to export Banco Itau widget");
      throw err;
    }
  }

  upgradeColumnStates(colDefs: ColDef[], colState: ColumnState[]) {
    const columnsInData = new Set(colDefs.map(cd => cd.colId));
    const columnsNotInData = colState.filter(col => !columnsInData.has(col.colId) && col.colId !== 'ag-Grid-AutoColumn');
    if (columnsNotInData.length === 0)
        return false; // no conversion

    // convert missing states where possible
    for (const columnState of columnsNotInData) {
        if (columnsInData.has(`Date_${columnState.colId}`))
            columnState.colId = `Date_${columnState.colId}`;
        else if (columnsInData.has(`EmpHierarchy_${columnState.colId}`))
            columnState.colId = `EmpHierarchy_${columnState.colId}`;
        else if (columnsInData.has(`ContactHierarchy_${columnState.colId}`))
            columnState.colId = `ContactHierarchy_${columnState.colId}`;
    }
    return true;
}
}
